/* eslint-disable @reatom/unit-naming-rule */
import { action, onConnect, reaction, withConcurrency } from '@reatom/framework'

import { Result, type TypeHelper } from '@blade/std-lib'
import { selectedNetworkAtom } from '@root/entities/network'
import { pairRegistry } from '@root/entities/pair/atoms'
import { reatomRequest } from '@root/shared/lib'

import * as CoinsLaunchedTime from '../model/coins-launched-time'
import * as CoinsType from '../model/coins-type'

import { fetchMyCoinsRequestAction } from './fetch-coins-request-action'

import type { FetchMyCoinsArgs } from './fetch-coins-request-action'
import type { DelugeId } from '@root/entities/user-short'

export const lastCreatedCoins = (options: { delugeId: DelugeId }) => {
  const fetchData = action(
    async (ctx, params: TypeHelper.OmitKey<FetchMyCoinsArgs, 'delugeId'>) => {
      const result = await ctx.schedule(() =>
        fetchMyCoinsRequestAction(ctx, {
          ...params,
          delugeId: options.delugeId,
        }),
      )

      return result.pipe(
        Result.map((it) =>
          it.map((dto) => pairRegistry.resolveFromDto(ctx, dto)),
        ),
      )
    },
  )
  const lastCreatedCoinsStateAtom = reatomRequest({
    name: 'lastCreatedCoinsState',
    execAction: fetchData,
  })

  const filterStateChangeReaction = reaction(async (ctx) => {
    await ctx.schedule(() =>
      lastCreatedCoinsStateAtom.execute(ctx, {
        coinsType: CoinsType.Created,
        launchedTime: CoinsLaunchedTime.all,
        selectedNetwork: ctx.get(selectedNetworkAtom),
      }),
    )
  }, 'filterStateChangeReaction').pipe(withConcurrency())

  onConnect(lastCreatedCoinsStateAtom, (ctx) => {
    const filterStateReactionResult = filterStateChangeReaction(ctx)

    return () => {
      filterStateReactionResult.unsubscribe()
    }
  })

  return {
    lastCreatedCoinsStateAtom,
  }
}
